import React, { useState } from "react";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AuthModal from "./AuthModal";

export default function RequireUser({ children, message = "Sign in to continue." }) {
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);
  if (loading) return <div className="py-24 text-center text-white/40">Loading…</div>;
  if (user) return children;
  return (
    <div className="py-24 text-center" data-testid="require-login">
      <Lock className="mx-auto text-white/30" size={32} />
      <h2 className="mt-4 text-2xl font-bold text-white">Sign in required</h2>
      <p className="mt-2 text-white/50">{message}</p>
      <button onClick={() => setOpen(true)} data-testid="require-login-btn" className="mt-6 px-6 py-2.5 rounded-full bg-white text-black font-bold hover:bg-white/90">Sign In</button>
      <AuthModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
